import styled from "styled-components";

export const ViewSelectionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1.5rem;
  min-height: 100vh;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding: 6rem 1rem 2rem 1rem;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    gap: 2rem;
    padding: 4rem 2rem;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    padding: 4rem 0;
  }
`;

export const JobNimbusLogo = styled.img`
  width: auto;
  height: 2rem;
  alt: "JobNimbus Logo";
  position: static;
  margin: 0 auto 1rem;
  display: block;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    height: 3rem;
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;
    margin: 0;
  }
`;

export const PageTitle = styled.div`
  color: #000;
  font-family: "DM Sans";
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: center;
  position: static;
  margin-bottom: 1.5rem;
  opacity: 0.2;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    font-size: 2rem;
    position: absolute;
    top: 0.5rem;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 0;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    font-size: 2.5rem;
  }
`;

export const RowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  max-width: 320px;

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    flex-direction: row;
    gap: 1.5rem;
    max-width: none;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    gap: 2rem;
  }
`;

// BASE CRM PACKAGE
export const ViewOptionCard = styled.button`
  width: 100%;
  min-width: 280px;
  max-width: 320px;
  height: 6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  flex-shrink: 0;
  border-radius: 1.25rem;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  border: none;
  outline: ${(props) => (props.selected ? "4px solid #3B5EAB" : "none")};
  /* Ensure minimum touch target */
  min-height: 44px;
  padding: 1rem;
  
  /* Improve touch interaction */
  -webkit-tap-highlight-color: rgba(59, 94, 171, 0.1);

  h2 {
    margin: 0;
    font-size: 1.125rem;
    font-weight: 600;
  }

  &:hover {
    cursor: pointer;
    outline: 4px solid ${(props) => (props.selected ? "#3B5EAB" : "#A9A9A9")};
  }

  &:active {
    transform: translateY(1px);
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  }

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    width: 12rem;
    height: 7rem;
    min-width: auto;
    max-width: none;

    h2 {
      font-size: 1.25rem;
    }
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    width: 15rem;
    height: 8rem;

    h2 {
      font-size: 1.5rem;
    }
  }
`;

export const NextPageButton = styled.button`
  width: 100%;
  min-width: 280px;
  max-width: 320px;
  height: 4rem;
  border-radius: 1.25rem;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  border: none;
  outline: none;
  outline: ${(props) => (props.selected ? "4px solid #3B5EAB" : "none")};
  /* Ensure minimum touch target */
  min-height: 44px;
  
  /* Improve touch interaction */
  -webkit-tap-highlight-color: rgba(59, 94, 171, 0.1);

  h2 {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: #3B5EAB;
  }

  &:hover {
    cursor: pointer;
    outline: 4px solid ${(props) => (props.selected ? "#3B5EAB" : "#A9A9A9")};
  }

  &:active {
    transform: translateY(1px);
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
  }

  /* Tablet styles: 640px and up */
  @media (min-width: 640px) {
    width: 10rem;
    height: 4.5rem;
    min-width: auto;
    max-width: none;
  }

  /* Desktop styles: 1024px and up */
  @media (min-width: 1024px) {
    width: 10rem;
    height: 5rem;
    
    h2 {
      font-size: 1.5rem;
    }
  }
`;
